module.exports = __webpack_public_path__ + "static/designer-view.fe627734.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/designer-view.png
// module id = 141
// module chunks = 35783957827783 94473201756134